import {
  Modal,
  Table,
  Progress,
  Statistic,
  Row,
  Col,
  Alert,
  Skeleton,
  Button,
} from "antd";
import { useEffect, useReducer, useState, useContext } from "react";
import { packageDeliveryWithoutMessage, printBarcode } from "@DELIVERIES";
import useRequestQueue from "./hooks/request-queue";
import { b64toBlob, TermalPrint } from "@HELPERS";
import PrintModal from "../../operation/table/print-modal";
import { AuthContext } from "@CONTEXTS";
import { useHistory } from "react-router-dom";
import { exportExcel } from "@HELPERS";

const initialState = [];
const reducer = (state, action) => {
  const { type, payload } = action;

  switch (type) {
    case "SET_DELIVERIES":
      return payload.map((delivery) => ({
        ...delivery,
        status: "RUNNING",
      }));
    case "UPDATE_DELIVERY_STATUS_SUCCESS":
      return state.map((delivery) => {
        if (delivery.id === payload.id) {
          return {
            ...delivery,
            status: "SUCCESS",
          };
        }
        return delivery;
      });
    case "UPDATE_DELIVERY_STATUS_ERROR":
      return state.map((delivery) => {
        if (delivery.id === payload.id) {
          return {
            ...delivery,
            status: "ERROR",
            errorMessage: payload.errorMessage,
          };
        }
        return delivery;
      });
    default:
      break;
  }
};

const PackageResultModal = ({
  onClose,
  data,
  excel,
  preOrderErrorList,
  excelOnClose,
}) => {
  const [state, dispatch] = useReducer(reducer, initialState);
  const [successCount, setSuccessCount] = useState(0);
  const [errorCount, setErrorCount] = useState(0);
  const [waitingCount, setWaitingCount] = useState(0);
  const [mounted, setMounted] = useState(false);
  const [loading, setLoading] = useState(false);
  const [succesBarcodes, setSuccessBarcodes] = useState([]);
  const [errorBarcodes, setErrorBarcodes] = useState(
    preOrderErrorList?.length > 0 ? preOrderErrorList : []
  );
  const [printModal, setPrintModal] = useState(false);
  const history = useHistory();
  const { info } = useContext(AuthContext);
  const columns = [
    {
      title: "Sipariş numarası",
      dataIndex: "customerDeliveryNo",
      key: "customerDeliveryNo",
      width: "25%",
    },
    {
      title: "Barkod",
      dataIndex: "barcode",
      key: "barcode",
      width: "25%",
    },
    {
      title: "Durum",
      dataIndex: "status",
      key: "status",
      width: "50%",
      render: (data, record) => {
        switch (data) {
          case "RUNNING":
            return <Skeleton.Input active block shape="round" size="small" />;
          case "SUCCESS":
            return <Progress percent={100} size="small" />;
          case "ERROR":
            return (
              <Alert message={record.errorMessage} type="error" showIcon />
            );
          default:
            return "HATA!";
        }
      },
    },
  ];

  const { enqueue } = useRequestQueue(5); // Eş zamanlı maksimum 5 istek

  useEffect(() => {
    dispatch({ type: "SET_DELIVERIES", payload: data });
  }, [data, dispatch]);

  useEffect(() => {
    if (state) {
      const success = state?.filter(
        (delivery) => delivery.status === "SUCCESS"
      );
      const error = state?.filter((delivery) => delivery.status === "ERROR");
      const waiting = state?.filter(
        (delivery) => delivery.status === "RUNNING"
      );

      setSuccessCount(success.length);
      setErrorCount(error.length);
      setWaitingCount(waiting.length);

      if (waiting.length === 0) {
        setSuccessBarcodes(
          success.map((item) => ({
            customerDeliveryNo: item.barcode,
            totalParcels: item.totalParcels,
          }))
        );
        if (error.length > 0 && excel) {
          setErrorBarcodes([
            ...errorBarcodes,
            ...error.map((item) => ({
              "Sipariş Numarası": item.item.customerDeliveryNo,
              Desi: item.item.desi,
              "Kaç Parça": item.item.totalParcels,
              "Alıcı Adı": item.item.recipient.firstName,
              "Alıcı Soyadı": item.item.recipient.lastName,
              "Telefon Numarası": item.item.recipient.phone,
              İl: item.item.recipient.address.city.name,
              İlçe: item.item.recipient.address.town.name,
              Mahalle: item.item.recipient.address?.district?.name,
              errorMessage: item.errorMessage,
            })),
          ]);
        }
        setLoading(false);
      }
    }
  }, [data, state, dispatch]);

  const downloadErrorDeliveries = () => {
    exportExcel(
      "Hatalı Gönderiler",
      [
        { title: "Sipariş Numarası", key: "Sipariş Numarası" },
        { title: "Desi", key: "Desi" },
        { title: "Kaç Parça", key: "Kaç Parça" },
        { title: "Alıcı Adı", key: "Alıcı Adı" },
        { title: "Alıcı Soyadı", key: "Alıcı Soyadı" },
        { title: "Telefon Numarası", key: "Telefon Numarası" },
        { title: "İl", key: "İl" },
        { title: "İlçe", key: "İlçe" },
        { title: "Mahalle", key: "Mahalle" },
        { title: "Açık Adres", key: "Açık Adres" },
        { title: "Hata Sebebi", key: "errorMessage" },
      ],
      errorBarcodes
    );
  };

  const handlePrint = async () => {
    setLoading(true);
    const response = await printBarcode(succesBarcodes);
    setLoading(false);
    if (response?.pdf) {
      const b64 = b64toBlob(response.pdf, "application/pdf");
      const blobUrl = URL.createObjectURL(b64);
      setPrintModal(blobUrl);
    }
    if (response?.zplArray) {
      TermalPrint(response?.zplArray);
    }
  };
  useEffect(() => {
    if (state && state.length > 0 && !mounted) {
      state.forEach((item) => {
        enqueue(() => packageDeliveryWithoutMessage(item.id, excel))
          .then((response) => {
            if (response.success) {
              dispatch({
                type: "UPDATE_DELIVERY_STATUS_SUCCESS",
                payload: { id: item.id },
              });
            } else {
              dispatch({
                type: "UPDATE_DELIVERY_STATUS_ERROR",
                payload: {
                  id: item.id,
                  errorMessage:
                    response?.response?.data?.message || "Bir sorun oluştu",
                },
              });
            }
          })
          .catch((error) => {
            console.error(error);
            // Hata işleme
            dispatch({
              type: "UPDATE_DELIVERY_STATUS_ERROR",
              payload: { id: item.id, errorMessage: "Bir sorun oluştu." },
            });
          });
      });
      setMounted(true);
      setLoading(true);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [state]);
  return (
    <>
      {printModal && (
        <PrintModal data={printModal} onClose={() => setPrintModal(false)} />
      )}
      <Modal
        visible
        title="Toplu Gönderi Paketleme Durumu"
        onCancel={() => {
          if (!loading) {
            onClose();
            if (info.autoPackage && excel) excelOnClose();
          }
        }}
        width={950}
        footer={null}
      >
        <Row gutter={24}>
          <Col span={8}>
            <Statistic title="Başarılı Gönderi Sayısı" value={successCount} />
          </Col>
          <Col span={8}>
            <Statistic
              title="Hatalı Gönderi Sayısı"
              value={
                preOrderErrorList && preOrderErrorList?.length > 0
                  ? preOrderErrorList?.length
                  : 0 + errorCount
              }
            />
          </Col>
          <Col span={8}>
            <Statistic
              title="Sırada Bekleyen Gönderi Sayısı"
              value={waitingCount}
            />
          </Col>
        </Row>
        <div style={{ marginTop: 24 }}>
          <Table
            pagination={false}
            columns={columns}
            dataSource={state}
            scroll={{ y: 400 }}
            bordered
            rowKey="barcode"
          />
        </div>
        <Row style={{ marginTop: 16 }} align="center" gutter={12}>
          {succesBarcodes && (
            <>
              {succesBarcodes.length > 0 &&
                info.authorities.includes("PRINT_BARCODE") && (
                  <Col>
                    <Button key="print" onClick={() => handlePrint()}>
                      Barkod Yazdır
                    </Button>
                  </Col>
                )}
              {succesBarcodes.length > 0 && (
                <Col>
                  <Button
                    type="primary"
                    key="console"
                    onClick={() => history.push("/deliveries/operation")}
                  >
                    Operasyondaki Gönderilerim
                  </Button>
                </Col>
              )}
            </>
          )}
          {waitingCount === 0 && errorBarcodes.length > 0 && excel && (
            <Col>
              <Button
                type="primary"
                danger
                onClick={() => downloadErrorDeliveries()}
              >
                Hatalı Gönderileri İndir
              </Button>
            </Col>
          )}
        </Row>
      </Modal>
    </>
  );
};

export default PackageResultModal;
